import type { TApiApplicationDocument } from '~/modules/covenants/types.ts';

type TGeneratedCertificate = {
  id: number;
};

type TCompleteCertificateGenerationParams = {
  generate: () => Promise<TGeneratedCertificate>;
  refreshGeneratedDocument: (documentId: string) => Promise<void>;
  regenerationSource?: TApiApplicationDocument;
  finalizeRegeneration: (source: TApiApplicationDocument) => Promise<boolean>;
};

export const completeCertificateGeneration = async ({
  generate,
  refreshGeneratedDocument,
  regenerationSource,
  finalizeRegeneration,
}: TCompleteCertificateGenerationParams): Promise<boolean> => {
  const generatedDocument = await generate();
  await refreshGeneratedDocument(String(generatedDocument.id));

  if (!regenerationSource) return true;

  return finalizeRegeneration(regenerationSource);
};
